import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useOrgTier } from '../hooks/useOrgTier';

/**
 * Route guard that only lets Pro-tier orgs through. Standard tenants
 * trying to deep-link into a Pro feature get bounced to `/dashboard`
 * with an unauthorized notification banner. Renders nothing while the
 * tier resolution is still pending so we never flash Pro content to a
 * Standard user.
 */
export function ProRoute({ children, redirectTo = '/dashboard', message }) {
  const { isPro, ready } = useOrgTier();
  const warned = useRef(false);

  useEffect(() => {
    if (ready && !isPro && !warned.current) {
      warned.current = true;
      toast.error(
        message ||
          'E-Invoice is a Pro-tier feature. Upgrade your plan to access this module.',
        { duration: 6000 }
      );
    }
  }, [ready, isPro, message]);

  if (!ready) return null;
  if (!isPro) return <Navigate to={redirectTo} replace />;
  return children;
}

export default ProRoute;
